import { message } from 'antd'
import Api, { makeRequest } from 'api'
import { uploadFile } from 'store/authSlice/authActions'
import { showErrorMessage, sortByDate, sortByZipcode } from 'utils'
import moment from 'moment'
import { auctionActions } from './auctionReducer'

export const addAuction = (payload, setLoading, actions) => async () => {
  setLoading(true)
  try {
    let updatedData = payload
    if (!updatedData?.Flyer?.fileName) {
      const flyerFile = await uploadFile(updatedData.Flyer)
      updatedData = {
        ...updatedData,
        Flyer: {
          fileName: flyerFile.fileName,
          fileMimeType: flyerFile.fileMimeType,
        },
      }
    }

    // Auction Item Image Upload
    if (updatedData.AuctionItemsList) {
      /* eslint-disable no-await-in-loop */
      for (let i = 0; i < updatedData.AuctionItemsList.length; i += 1) {
        const item = updatedData.AuctionItemsList[i]
        if (item?.itemImage?.originFileObj) {
          const itemFile = await uploadFile(item.itemImage.originFileObj)
          item.itemImage = {
            fileName: itemFile.fileName,
            fileMimeType: itemFile.fileMimeType,
          }
        }
        updatedData.AuctionItemsList[i] = item
      }
      /* eslint-disable no-await-in-loop */
    }

    makeRequest(
      'put',
      '/auction',
      {
        checkPermission: true,
      },
      updatedData,
    )
      .then(() => {
        setLoading(false)
        message.success('Auction Added Successfully')
        if (actions) {
          actions()
        }
      })
      .catch((error) => {
        showErrorMessage(error)
        setLoading(false)
      })
  } catch (error) {
    showErrorMessage(error)
    setLoading(false)
  }
}

export const updateAuction = (payload, setLoading, actions) => async () => {
  setLoading(true)
  try {
    let updatedData = payload
    if (!updatedData?.Flyer?.fileName) {
      const flyerFile = await uploadFile(updatedData.Flyer)
      updatedData = {
        ...updatedData,
        Flyer: {
          fileName: flyerFile.fileName,
          fileMimeType: flyerFile.fileMimeType,
        },
      }
    }

    makeRequest(
      'put',
      '/auction/updateAuction',
      {
        checkPermission: true,
      },
      updatedData,
    )
      .then(() => {
        setLoading(false)
        message.success('Auction Updated Successfully')
        if (actions) {
          actions()
        }
      })
      .catch((error) => {
        showErrorMessage(error)
        setLoading(false)
      })
  } catch (error) {
    showErrorMessage(error)
    setLoading(false)
  }
}

// We are not using this now
export const geNearByAuction = (body, sortKey) => (dispatch) => {
  dispatch(auctionActions.setLoading(true))
  Api.post('/auction/nearBy', body)
    .then((res) => {
      const sortedData = sortByDate(res?.results, sortKey)
      dispatch(auctionActions.setAuctions(sortedData))
      dispatch(auctionActions.setLoading(false))
    })
    .catch((error) => {
      console.log('error', error)
      dispatch(auctionActions.setLoading(false))
    })
}

// We are not using this now
export const getAllAuction = (loadingOff, zipCode) => (dispatch) => {
  Api.get('/auction/all')
    .then((res) => {
      const sortedData = sortByZipcode(res?.results, 'ZipCode', zipCode)
      dispatch(auctionActions.setAllAuctions(sortedData))
      loadingOff()
    })
    .catch((error) => {
      console.log('error', error)
      dispatch(auctionActions.setAllAuctions([]))
      loadingOff()
    })
}

// We are not using this now
export const getAuctions = (sortKey) => (dispatch) => {
  dispatch(auctionActions.setLoading(true))
  Api.get('/auction/all')
    .then((res) => {
      const sortedData = sortByDate(res?.results, sortKey)
      dispatch(auctionActions.setAuctions(sortedData))
      dispatch(auctionActions.setLoading(false))
    })
    .catch((error) => {
      console.log('error', error)
      dispatch(auctionActions.setLoading(false))
    })
}

export const getAuctionBySubscriber = (sortKey, id) => (dispatch) => {
  dispatch(auctionActions.setLoading(true))
  makeRequest('get', `/auction/getBySubscriber?id=${id}`, {
    checkPermission: true,
  })
    .then((res) => {
      if (res.results) {
        const sortedData = sortByDate(res?.results, sortKey)
        dispatch(auctionActions.setAuctions(sortedData))
      } else {
        dispatch(auctionActions.setAuctions([]))
      }
      dispatch(auctionActions.setLoading(false))
    })
    .catch((error) => {
      showErrorMessage(error)
      dispatch(auctionActions.setAuctions([]))
      dispatch(auctionActions.setLoading(false))
    })
}

export const getAuctionForUpdate = (id, form, duplicate) => (dispatch) => {
  dispatch(auctionActions.setLoading(true))
  makeRequest('get', `/auction/getAuction/${id}`, {
    checkPermission: true,
  })
    .then((res) => {
      if (res.results) {
        const auction = res.results
        if (form) {
          form.setFieldsValue({
            Title: auction?.Title,
            ZipCode: auction?.ZipCode,
            StartDate:
              !duplicate && auction?.StartDate && moment(auction?.StartDate),
            EndDate: !duplicate && auction?.EndDate && moment(auction?.EndDate),
            Details: auction?.Details,
            ShowOnPage: auction?.ShowOnPage,
            Flyer: auction?.Flyer && auction?.Flyer,
          })
        }
      }
      dispatch(auctionActions.setLoading(false))
    })
    .catch((error) => {
      showErrorMessage(error)
      dispatch(auctionActions.setLoading(false))
    })
}

export const getAuctionDetails = (id) => (dispatch) => {
  dispatch(auctionActions.setLoading(true))
  makeRequest('get', `/auction/getAuction/${id}`, {
    checkPermission: true,
  })
    .then((res) => {
      if (res.results) {
        dispatch(auctionActions.setAuction(res.results))
      } else {
        dispatch(auctionActions.setAuction(null))
      }
      dispatch(auctionActions.setLoading(false))
    })
    .catch((error) => {
      showErrorMessage(error)
      dispatch(auctionActions.setAuction(null))
      dispatch(auctionActions.setLoading(false))
    })
}

export const updateAuctionStatus =
  (auctionId, status, nagigate) => (dispatch) => {
    dispatch(auctionActions.setLoading(true))
    const modifiedStatus = status === 1 ? 0 : 1
    makeRequest(
      'put',
      `/auction/changeActiveStatus`,
      {
        checkPermission: true,
      },
      {
        id: auctionId,
        status: modifiedStatus,
      },
    )
      .then(() => {
        dispatch(auctionActions.setLoading(false))
        if (status === 1) {
          message.success('Event Deactivated Successfully')
        } else {
          message.success('Event Activated Successfully')
        }
        if (nagigate) {
          nagigate()
        }
      })
      .catch((error) => {
        showErrorMessage(error)
        dispatch(auctionActions.setLoading(false))
      })
  }
